import PageCard from 'features/shared/components/card/PageCard';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InvoiceDTO from '../dtos/InvoiceDTO';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import AddressDTO from 'features/shared/dtos/AddressDTO';
import AddressFormatter from 'features/shared/components/formatters/AddressFormatter';
import { formatDate } from 'features/shared/helpers/Formatters';
import styles from './invoicebasicinfocard.module.scss';
import { InvoiceType } from '../enums/invoiceType';
import { InvoiceSubType } from '../enums/invoiceSubType';

const productionSubTypes = [InvoiceSubType.ProductionInvoice, InvoiceSubType.CorrectedProductionInvoice];

interface Props {
  invoice: InvoiceDTO;
}

const InvoiceBasicInfoCard = ({ invoice }: Props) => {
  // translations
  const { t } = useTranslation(["invoice\\enums\\invoiceSubType"]);
  const tLabels = useTranslation("invoice\\invoice").t;

  // sub-renders
  const renderSubjectInfo = (name?: string, address?: AddressDTO) => {
    return (
      <div className="mt-1">
        <div className="font-weight-bold">{name}</div>
        <AddressFormatter address={address!} className="mt-n1"/>
      </div>
    );
  }

  const renderInlineInfo = (title?: string, value?: string) => {
    return (
      <div className="d-flex flex-wrap">
        <div className={`text-muted ${styles.inlineInfoTitle}`}>
          {title}:
        </div>
        <div className="font-weight-bold">
          {value}
        </div>
      </div>
    );
  }

  const renderSupplierInfo = () => { 
    if (productionSubTypes.includes(invoice.invoiceSubType!)) {
      return renderSubjectInfo(invoice.customerName, invoice.customerAddress);
    } else {
      return renderSubjectInfo(invoice.supplierName, invoice.supplierAddress);
    }
  }

  const renderCustomerInfo = () => { 
    if (productionSubTypes.includes(invoice.invoiceSubType!)) {
      return renderSubjectInfo(invoice.supplierName, invoice.supplierAddress);
    } else {
      return renderSubjectInfo(invoice.customerName, invoice.customerAddress);
    }
  }

  // render
  return (
    <PageCard title={t(invoice.invoiceSubType || "")} bodyClassName="pb-1">
      <div className="row no-gutters">
        <div className="col-sm-auto pr-sm-5 mb-2 mb-sm-3 col-xl-4">
          <InfoItem title={tLabels("invoiceBasicInfoCard.supplierName")} valueBold={false} value={renderSupplierInfo()}/>
        </div>
        <div className="col-sm-auto pr-sm-5 mb-2 mb-sm-3 col-xl-4">
          <InfoItem title={tLabels("invoiceBasicInfoCard.customerName")} valueBold={false} value={renderCustomerInfo()}/>
        </div>
        <div className="col-sm-auto mb-2 mb-sm-3 col-xl-4">
          {renderInlineInfo(tLabels("invoiceBasicInfoCard.invoiceNumber"), invoice.invoiceNumber)}
          {renderInlineInfo(tLabels("invoiceBasicInfoCard.issueDate"), formatDate(invoice.issueDate!))}
          {renderInlineInfo(tLabels("invoiceBasicInfoCard.dueDate"), formatDate(invoice.dueDate!))}
          {invoice.invoiceType == InvoiceType.Invoice &&
            renderInlineInfo(tLabels("invoiceBasicInfoCard.taxDate"), formatDate(invoice.taxDate!))
          }
        </div>
      </div>
    </PageCard>
  )
}

export default InvoiceBasicInfoCard;
